import { adminPages } from './page-registry';

export function modulePathForPage(id: string): string {
  if (id.startsWith('ADM-L')) return '/admin/ad-landings';
  if (['ADM-A08'].includes(id)) return '/admin/audit/overview';
  if (
    [
      'ADM-A07',
      'ADM-J01',
      'ADM-J02',
      'ADM-J03',
      'ADM-J04',
      'ADM-J05',
      'ADM-J06',
      'ADM-J11',
    ].includes(id)
  )
    return '/admin/security/users';
  if (['ADM-B01', 'ADM-B02', 'ADM-B03'].includes(id)) return '/admin/cities';
  if (id.startsWith('ADM-B')) return '/admin/apps';
  if (id.startsWith('ADM-C')) return '/admin/products';
  if (id.startsWith('ADM-D')) return '/admin/cms/templates';
  if (id === 'ADM-E10' || ['ADM-I04', 'ADM-I05', 'ADM-I06', 'ADM-I07', 'ADM-I08'].includes(id))
    return '/admin/finance/order-profit';
  if (id.startsWith('ADM-E')) return '/admin/orders';
  if (id.startsWith('ADM-F')) return '/admin/members';
  if (id.startsWith('ADM-G')) return '/admin/payments/merchants';
  if (id.startsWith('ADM-H')) return '/admin/marketing/coupons';
  if (id.startsWith('ADM-I')) return '/admin/messages/templates';
  if (id.startsWith('ADM-J')) return '/admin/system/settings';
  return '/admin/dashboard';
}

// Detail routes remain contextual: operators choose a record before editing it.
export function moduleEntries(modulePath: string) {
  const securityOrder = ['ADM-J11', 'ADM-J02', 'ADM-J01'];
  if (modulePath === '/admin/security/users')
    return securityOrder.flatMap((id) => adminPages.filter((page) => page.id === id));
  return adminPages.filter(
    (page) =>
      page.id !== 'ADM-A01' &&
      !page.path.includes(':') &&
      modulePathForPage(page.id) === modulePath,
  );
}
